import ProcessNavigation from '@/components/process-navigation/index.vue';
import Service from '@/service/index.js';
import { mapGetters } from 'vuex';

export default {
  components: {
    ProcessNavigation
  },
  data() {
    return {
      id: '',
      oldId: '',
      activeIndex: 0,
      tableList: ['农村集体服务或货物采购项目交易流程图（预算30万元以下）', '农村集体工程建设类项目交易流程图（概算60万元以下）'],
      // processList: ['业务流程及准备材料', '编辑项目信息', '编辑意向供应人（投标人）资格要求', '上传附件信息', '确定承诺信息', '编辑采购文件', '提交申请'],
      ruleForm: {
        type: '',
        name: '',
        idCard: '',
        mobile: '',
        householdsType: '',
        address: '',
        companyName: '',
        creditCode: '',
        email: '',
        legalName: '',
        legalMobile: '',
        legalIdType: '',
        legalIdCard: '',
        assignor: '',
        assignorIdType: '',
        assignorIdCard: '',
        assignorMobile: ''
      }
    };
  },
  created () {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    Service.getUserBaseInfo().then(res => {
      if (!res.data) {
        return;
      }
      Object.keys(this.ruleForm).forEach((key) => {
        this.ruleForm[key] = res.data && String(res.data[key]);
      });
    });
  },
  computed: {
    ...mapGetters({
      processList: 'purchaseProcessList',
      getTenantParams: 'getTenantParams'
    })
  },
  methods: {
    next() {
      let str = '';
      if (this.id && this.oldId) {
        str = '?id=' + this.id + '&oldId=' + this.oldId;
      } else if (this.id) {
        str = '?id=' + this.id;
      } else if(this.oldId) {
        str = '?oldId=' + this.oldId;
      }
      this.$router.push('/publish-purchase/purchase-form' + str);
    }
  }
};
